export default __webpack_public_path__ + "static/media/audience-blob.ab7332da.jpg";